export class Company {
  id: number;
  name: string;
  address: string;
  cif: string;
  zip: null;
  idNavision: string;
  web: string;
  group: any;
  phone: string;
  commercialCondition: any;
  groupId: number;
  office_city: string;
  country: string;
  offices: any;

  constructor() {
  	this.id = null;
  	this.name = null;
  }
}
